import {computed, ref, reactive, watch} from "vue";
import escapeStringRegexp from 'escape-string-regexp';

const items = ref([])

const groups = ref([])
const groupsSelected = ref([])
const treeChecked = ref([])
const catalogueType = ref({ext: {properties: []}})
const itemSelectedObject = ref({ext: {Images: []}})
const currentPage = ref(1)
const filter = ref('')
const filterExact = ref(false)
const perPage = ref(10)
const itemsTable = reactive({value: null});


const getDesc = () => {
  if (!filter.value) {
    return '<div>' + itemSelectedObject.value.ext.Description + '</div>'
  }
  let desc = cleanHtml(JSON.parse(JSON.stringify(itemSelectedObject.value.ext.Description)));
  let leftArrow = desc.split('<');
  leftArrow.map((la, laKey) => {
    let rightSlashArrow = la.split('/>');
    if (rightSlashArrow.length === 2) {
      rightSlashArrow[1] = replaceFilter(rightSlashArrow[1]);
    } else {
      let rightArrow = rightSlashArrow[0].split('>');
      if (rightArrow.length === 2) {
        rightArrow[1] = replaceFilter(rightArrow[1]);
      }
      rightSlashArrow[0] = rightArrow.join('>')
    }
    leftArrow[laKey] = rightSlashArrow.join('/>')
  }, leftArrow)
  desc = leftArrow.join('<')
  return '<div>' + desc + '</div>';
}

const getDescriptionV2 = computed(() => {
  return getDesc();
});

const cleanHtml = (html) => {
  html = html.replace(/(?:\\[rn]|[\r\n]+)+/g, "");
  let txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
}

const replaceFilter = (text) => {
  let filterText = escapeStringRegexp(filter.value);
  let re;
  if (filterExact.value) {
    re = new RegExp('\\b(' + filterText + ')\\b', 'gi')
  } else {
    re = new RegExp('(' + filterText + ')', 'gi');
  }
  return text.replace(re, '<mark>$1</mark>', "gi");
}

const ItemsFiltered = computed(() => {

  let filtered = [];
  if (groupsSelected.value.length) {
    // Show items linked to ANY of the selected groups (union, not intersection).
    // The tree mixes checked and half-checked ancestor keys; requiring ALL
    // would filter out plants that only carry leaf links.
    const selectedGroups = groupsSelected.value.map(group => String(group));
    filtered = items.value.filter(item => {
      const linkedCatalogue = item.links && item.links.catalogue ? item.links.catalogue : [];
      if (!linkedCatalogue.length) return false;
      const itemGroupIds = linkedCatalogue.map(catalogue => String(catalogue.id));
      return selectedGroups.some(groupId => itemGroupIds.includes(groupId));
    });
  } else {
    filtered = items.value;
  }

  let userFiltered = [];
  if (filter.value) {
    let filterText = escapeStringRegexp(filter.value);

    let re;
    if (filterExact.value) re = new RegExp('\\b(' + filterText + ')\\b', 'gi');
    else re = new RegExp('(' + filterText + ')', 'gi');
    filtered.map(function (item) {
      const dom = new DOMParser().parseFromString(item.ext.Description, 'text/html');
      let desc = dom.body.textContent;
      if (desc.match(re)) {
        userFiltered.push(item);
      }
    });
    filtered = userFiltered;
    userFiltered = [];
  }


  catalogueType.value.ext.properties.map(function (prop, propKey) {

    if (prop.type === 'select' && prop.filter) {
      filtered.map(function (item, itemKey) {
        if (item.ext && item.ext[prop.name] === prop.filter) {
          userFiltered.push(item);
        }
      }, this);
      filtered = userFiltered;
      userFiltered = [];
    }

    if (multipleCheck(prop)) {
      filtered.map(function (item, itemKey) {
        let found = false;
        if (item.ext && item.ext[prop.name]) {
          for (const [itemSelectedKey, itemSelected] of Object.entries(item.ext[prop.name])) {
            if (itemSelected) {
              prop.filter.map(function (filter, filterKey) {
                if (itemSelectedKey === filter) {
                  found = true;
                }
              });
            }
          }
        }
        if (found) {
          userFiltered.push(item);
        }
      });
      filtered = userFiltered;
      userFiltered = [];
    }
  });

  return filtered
});

const updateUrl = (plantName, replace = false) => {
  const encoded = encodeURIComponent(plantName);
  const pathParts = window.location.pathname.replace(/\/$/, '').split('/');
  let lastDecoded = '';
  try {
    lastDecoded = decodeURIComponent(pathParts[pathParts.length - 1] || '');
  } catch (e) {
    lastDecoded = pathParts[pathParts.length - 1] || '';
  }
  const lastIsPlant = items.value.some(i => i.name === lastDecoded);
  if (lastIsPlant) {
    pathParts[pathParts.length - 1] = encoded;
  } else {
    pathParts.push(encoded);
  }
  const newUrl = pathParts.join('/') + window.location.search + window.location.hash;
  if (replace) {
    window.history.replaceState({}, '', newUrl);
  } else {
    window.history.pushState({}, '', newUrl);
  }
};

watch(ItemsFiltered, (newItems) => {
  currentPage.value = 1;
  if (!newItems.length) return;
  const selected = itemSelectedObject.value;
  const stillVisible = selected && selected.id !== undefined && newItems.some(i => i.id === selected.id);
  if (!stillVisible) {
    itemSelectedObject.value = newItems[0];
    updateUrl(newItems[0].name, true);
  }
});

const multipleCheck = (prop) => {
  let checked = 0;
  if (prop.type === 'multiple' && prop.filter) {
    Object.values(prop.filter).forEach(property => {
      property && checked++;
    });
  }
  return checked;
}

export default {
  items,
  ItemsFiltered,
  groups,
  groupsSelected,
  catalogueType,
  itemSelectedObject,
  currentPage,
  filter,
  filterExact,
  perPage,
  getDescriptionV2,
  replaceFilter,
  itemsTable,
  treeChecked,
  updateUrl,
};
